﻿/*
    When the user is scrolling horizontally on the comparison table, we actively apply classes to 
    add a drop shadow so it's more clear that the content is sliding under the left side headers. 
    We do this to make comparison when sliding more clear. 
*/

const responsiveWrapper = document.querySelector(".table-responsive");

if (!responsiveWrapper) return;

responsiveWrapper.addEventListener("scroll", () => {
    if (responsiveWrapper.scrollLeft > 0) {
        responsiveWrapper.classList.add("table-scrolled");
    } else {
        responsiveWrapper.classList.remove("table-scrolled");
    }
});